import React from "react";
import {connect} from "react-redux";
import PricingDetailsInputs from "./PricingDetailsInputs";
import PricingDetailsCheckboxes from "./PricingDetailsCheckboxes";
import PricingSection from "../PricingComponents/PricingSection";
import AddButton from "../PricingComponents/AddButton";
import {imagesPath} from "../../../utilities";


const PricingDetails = (props) => {

  const {presetName, } = props;

  const onCheckBoxChange = () => {

  }

  return (
    <PricingSection text={"Details"} sectionId={"pricingDetails"}>
      <div className="flex flex--center flex--start">
        <PricingDetailsInputs/>
        <PricingDetailsCheckboxes/>
        <div className="ml-3 pl-3 pr-details__cell flex flex--center flex--column text-center inactive">
          <img src={imagesPath('images/icons/pricing/scope.svg')} className="mt-1 mb-1" alt=""/>
          <span className="font--12 mb-1 color-light">Select a catalog from our library.</span>
          <AddButton text="Import Catalog"/>
        </div>
        <div className="ml-3 pl-3 pr-3 pr-details__cell flex flex--center flex--column text-center inactive">
          <img src={imagesPath('images/icons/pricing/upload.svg')} className="mt-1 mb-1" alt=""/>
          <span className="font--12 mb-1 color-light">Select to import or drag and drop</span>
          <AddButton text="Import Spreadsheet"/>
        </div>
      </div>
    </PricingSection>
  )
};

const mapStateToProps = (store) => {
  const {} = store.pricingState;
  return {};
};

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(PricingDetails);
